import FakeSearch, { Props } from './Fakesearch';

export default FakeSearch;
export type { Props as FakeSearchProps };
